var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    d: "M11.625 4.5V12.375C11.625 14.0325 10.2825 15.375 8.625 15.375C6.9675 15.375 5.625 14.0325 5.625 12.375V4.5C5.625 3.465 6.465 2.625 7.5 2.625C8.535 2.625 9.375 3.465 9.375 4.5V11.625C9.375 12.0375 9.0375 12.375 8.625 12.375C8.2125 12.375 7.875 12.0375 7.875 11.625V4.5H6.75V11.625C6.75 12.66 7.59 13.5 8.625 13.5C9.66 13.5 10.5 12.66 10.5 11.625V4.5C10.5 2.8425 9.1575 1.5 7.5 1.5C5.8425 1.5 4.5 2.8425 4.5 4.5V12.375C4.5 14.655 6.345 16.5 8.625 16.5C10.905 16.5 12.75 14.655 12.75 12.375V4.5H11.625Z",
    fill: "#1C192B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.ff968664ee78ddfc0b4f4a6bd4eb6240.svg";
export { ForwardRef as ReactComponent };